export default __webpack_public_path__ + "static/media/ictHealth.0b8e5862.jpg";